import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable, signal } from "@angular/core";
import { map, Observable, tap } from "rxjs";
import { environment } from "src/environments/environment";
import { IAajeevikaMemberRedisPayload } from "../components/models/dashboard.model";
import { HttpResponseType } from "../components/models/httpResponse.model";
import { ISaveUpdateAajeevikaReqBody, IUpdateLoanPayload } from "../interfaces/request-body.interface";
import { IDeleteAajeevikaMemberResponse, IDeleteLoanResponse, IGetAajeevikaMemberRedisRes, IGetLoanDetails, IGetMemberProfileResponse, IGetRejectionDetailsRes, IGetSHGList, ILoanDetailParam, InactiveLakhpatiDidiResponse, IPldPayload, ISaveAajeevikaMemberResponse, IUpdateAajeevikaMemberResponse, IUpdateCreateByRes, IUpdateLoanResponse, IUploadDataAajeevikaMemberResponse, LevelihoodActivitiesDetails, MappedPld, MappedPldRes, MappedSHGForCrpRes, Pld, PldRes, QuarterUpdateRes, SHGInfo, UpdateQuarterPayload } from "../interfaces/response.interface";
import { LocalService } from "./storage/storage.service";
import { CacheService } from "./cache.service";

export interface MemberBasicDetails {
    member_name: string;
    member_code: string;
    member_id: string;
    member_image: string;
    member_name_local?: string;
    isSurvey?: boolean;
    memberName?: string;

}
export interface MemberProfileDetails extends MemberBasicDetails {
    approve_status: number;
    cbo_id: number;
    degination: number;
    gender: number;
    is_active: number;
    is_verified: number;
    lddStatus: number;
    marital_status: number;
    mem_activation_status: number;
    mem_dedup_status: number;
    member_document: any;
    member_name_local: string;
    relation_name: string;
    shg_name: string;
    status: number;
    districtId?: number| string;
    isActive?: boolean;
    member_uuid?: string
}

export interface MemberProfileDetailsResponse extends HttpResponseType {
    responseData: MemberProfileDetails[];
}

@Injectable({
    providedIn: 'root'
})
export class MemberService {
    private baseUrl = environment.apiBaseUrl;
    private lokosBaseUrl = environment.lokosApiBaseUrl;
    useCachedCompletionDetail = signal(null);


    constructor(private http: HttpClient, private localService: LocalService, private cacheService: CacheService) { }

    getShgList (params: { blockId: string | number, panchayatId: string | number, villageId: string | number, districtId: string | number, stateId: string | number, sortDirection: string, sortColumn: string; }): Observable<IGetSHGList> {
        const url = `${environment.lokosApiBaseUrl}shg`;
        let headers;
        const xTenantIdetifier = this.localService.get('X-Tenant-Identifier');
        if (xTenantIdetifier) {
            headers = new HttpHeaders().set('X-Tenant-Identifier', xTenantIdetifier);
        }
        return this.http.get<IGetSHGList>(url, { headers, params: { ...params, flag: "OTHER" } }).pipe(map((response:any) => {
            const activatedShgs:SHGInfo[] = [];
            const otherShgs:SHGInfo[] = [];
            response.recordsList = response.recordsList.map((shg: SHGInfo) => {
                if(shg.is_active == 1 && shg.status == 1 && shg.activation_status == 2){
                    //activated by BPM
                    if(shg.approve_status == 2 && shg.is_verified != 1){
                        shg.shg_status = 'ACTIVATED_BY_BPM';
                        activatedShgs.push(shg);
                    } else if(shg.approve_status == 3){
                        shg.shg_status = 'REJECTED_BY_BPM';
                        otherShgs.push(shg);
                    } else if(shg.approve_status == 1){
                        shg.shg_status = 'PENDING_BY_BPM';
                        otherShgs.push(shg);
                    } else if((shg.approve_status == 2 && shg.is_verified == 1 )){
                        shg.shg_status = 'PENDING_BY_BK';
                        otherShgs.push(shg);
                    }
                }
                return shg;
            });
            response.activatedShg = [...activatedShgs];
            response.otherShg = [...otherShgs];

            return response;
        }));
    }


    getShgListUsingShgCode (params: { shgCode: string, stateId: string | number; blockId: string | number, districtId: string | number, }): Observable<IGetSHGList> {
        // const url = environment.urls.getMemberByShg;
        const url = `${environment.lokosApiBaseUrl}shg`;
        let headers;
        const xTenantIdetifier = this.localService.get('X-Tenant-Identifier');
        if (xTenantIdetifier) {
            headers = new HttpHeaders().set('X-Tenant-Identifier', xTenantIdetifier);
        }
        return this.http.get<IGetSHGList>(url, { headers, params: { ...params, flag: "OTHER" } });
    }

    getShgMembersList (id: number): Observable<MemberProfileDetailsResponse> {
        const url = `${environment.lokosApiBaseUrl}shg/${id}/members`;
        let headers;
        const xTenantIdetifier = this.localService.get('X-Tenant-Identifier');
        if (xTenantIdetifier) {
            headers = new HttpHeaders().set('X-Tenant-Identifier', xTenantIdetifier);
        }
        return this.http.get<MemberProfileDetailsResponse>(url, { headers });
    }

    getLakhpatiDidiByShg (shgCode?: string, details?: { blockId: string | number, panchayatId: string | number, villageId: string | number, districtId: string | number, stateId: string | number; }) {
        const params = shgCode ? { shgCode } : details;
        return this.http.get<any>(`${this.baseUrl}member/getLakhPatiDidiByShg`, { params });
    }

    saveAajeevikaMember (body: ISaveUpdateAajeevikaReqBody): Observable<ISaveAajeevikaMemberResponse> {
        return this.http.post<ISaveAajeevikaMemberResponse>(`${this.baseUrl}member`, body);
    }

    updateAajeevikaMember (id: string, body: ISaveUpdateAajeevikaReqBody, isOnlyLoan = false): Observable<IUpdateAajeevikaMemberResponse> {
        return this.http.post<IUpdateAajeevikaMemberResponse>(`${this.baseUrl}member/${id}`, body , {
          params: {isOnlyLoan}
        });
    }
    addNewFundingDetails(id: string, body: any): Observable<IUpdateAajeevikaMemberResponse> {
        return this.http.post<IUpdateAajeevikaMemberResponse>(`${this.baseUrl}member/${id}/funding-details`, body);

    }

    getMemberProfile (memberId: string | number, id: string, stateId: number, quarter: number, year: number, blockId: string): Observable<IGetMemberProfileResponse> {
      // const headers =  { 'Cache-Control': 'private, max-age=300' };
      return this.http.get<IGetMemberProfileResponse>(`${this.baseUrl}member/${memberId}`, { params: { stateId, quarter, year, id, blockId } })
      .pipe(map((response: any) => {
            // response.responseData.active = false;
            return response;
        }))
    }

    getLoanDetails (memberId: string | number, memberUuid: string, stateId: number, quarter: number|null, year: number, memberCode?:string, blockId?:string): Observable<IGetLoanDetails> {
      const params:any = { stateId, quarter, year, memberUuid };
      if(!quarter){
        delete params.quarter;
      }
      if(memberCode){
        params['memberCode']=memberCode
      }
      if(blockId){
        params['blockId']=blockId
      }
      if(!params.memberUuid){
        delete params.memberUuid;
      }
        return this.http.get<IGetLoanDetails>(`${this.baseUrl}member/${memberId}/loan`, { params: params });
    }

    getLivelihoodMembersDetails (id: string, quarter: number, year: number,blockId:string, stateId:string): Observable<LevelihoodActivitiesDetails> {
        return this.http.get<LevelihoodActivitiesDetails>(`${this.baseUrl}member/${id}/completion-detail`, { params: { quarter, year, blockId, stateId } });
    }

    deleteMemberProfile (id: string, quarter:number, year: number, blockId: string, stateId: string): Observable<IDeleteAajeevikaMemberResponse> {
        return this.http.delete<IDeleteAajeevikaMemberResponse>(`${this.baseUrl}member/${id}`, { params: { quarter, year, blockId, stateId } });
    }

    sendMemberForApproval (id: string, quarter: number, year: number, blockId: string, stateId: string): Observable<IUploadDataAajeevikaMemberResponse> {
        return this.http.put<IUploadDataAajeevikaMemberResponse>(`${this.baseUrl}member/${id}/status`, {}, { params: { quarter, year, blockId, stateId } });
    }
    saveAsset(memberUuid: string, body: any, blockId:string, stateId:string, quarter: number, year: number, memberId:number): Observable<any> {
      return this.http.post(`${this.baseUrl}memberAssets`, body, {params: {memberUuid, blockId, stateId, quarter, year, memberId}});
    }
    saveTraining(memberUuid: string, body: any, blockId:string, stateId:string, quarter: number, year: number, memberId:number): Observable<any> {
      return this.http.post(`${this.baseUrl}training-skills`, body, {params: {memberUuid, blockId, stateId, quarter, year, memberId}});
    }

    deleteLoan (id: string, memberUuid: string, blockId: string, stateId: string): Observable<IDeleteLoanResponse> {
        return this.http.delete<IDeleteLoanResponse>(`${this.baseUrl}member/${memberUuid}/loan/${id}`, {params: {memberUuid, blockId, stateId}});
    }
    deleteAsset (id: string, memberUuid: string,blockId:string, stateId:string, quarter: number, year: number, memberId:number): Observable<any> {
        return this.http.delete<IDeleteLoanResponse>(`${this.baseUrl}memberAssets/${id}`, {params: {memberUuid, blockId, stateId, quarter, year, memberId}});
    }
    deleteTraining (id: string, memberUuid: string,blockId:string, stateId:string, quarter: number, year: number, memberId:number): Observable<any> {
        return this.http.delete<IDeleteLoanResponse>(`${this.baseUrl}training-skills/${id}`, {params: {memberUuid, blockId, stateId, quarter, year, memberId}});
    }
    getAllTrainingDetails(memberUuid: string, blockId:string, stateId:string, quarter: number, year: number, memberId:number) : Observable<any> {
      return this.http.get(`${this.baseUrl}training-skills`, {params: {memberUuid, blockId, stateId, quarter, year, memberId}});
    }
    getAllAssetDetails(memberUuid: string, blockId:string, stateId:string, quarter: number, year: number, memberId:number) : Observable<any> {
      return this.http.get(`${this.baseUrl}memberAssets`, {params: {memberUuid, blockId, stateId, quarter, year, memberId}});
    }


    editLoan (body: IUpdateLoanPayload, memberUuid: string, id: string, blockId:string, stateId:string, quarter: number, year: number): Observable<IUpdateLoanResponse> {
        return this.http.put<IUpdateLoanResponse>(`${this.baseUrl}member/loan/${id}`, body, {params: {memberUuid, blockId, stateId, quarter, year}});
    }
    editAsset (body: IUpdateLoanPayload, memberUuid: string, id: string, quarter:number, year: number, memberId:number): Observable<IUpdateLoanResponse> {
        return this.http.put<IUpdateLoanResponse>(`${this.baseUrl}member/loan/${id}`, body, {params: {memberUuid, quarter, year, memberId}});
    }
    editTraining (body: IUpdateLoanPayload, memberUuid: string, id: string, quarter:number, year: number, memberId:number): Observable<IUpdateLoanResponse> {
        return this.http.put<IUpdateLoanResponse>(`${this.baseUrl}member/loan/${id}`, body, {params: {memberUuid, quarter, year, memberId}});
    }



    updateCreateBy (id: string): Observable<IUpdateCreateByRes> {
        return this.http.put<IUpdateCreateByRes>(`${this.baseUrl}member/updateMember/currentOwner/${id}`, {});
    }

    getMappedSHGForCRP (stateId: string, blockId: string): Observable<MappedSHGForCrpRes> {
      console.log("21212")
        return this.http.get<MappedSHGForCrpRes>(`${this.baseUrl}member/crp-lakhpati-mapping`,{params: {fullData: 'false', stateId, blockId}}).pipe(map((response: MappedSHGForCrpRes) => {
            response.responseData = response.responseData.filter((record: MappedPld) => record.shgId && !record.memberCode && record.crpName && !record.deleted);
            return response;
        }));
    }

      getMappedSHGForCRPV2(stateId: string, blockId: string,enableCaching = true, cacheTime = '300', forceRefresh = false): Observable<any> {
          const apiKey = this.cacheService.API_KEYS.MAPPED_SHG_LISTING;
          const params: any = {fullData: 'false', stateId, blockId} ;
          let headers = {};

          if (enableCaching) {
            headers = { 'Cache-Control': `private, max-age=${cacheTime}` };

            if (forceRefresh) {
              params['ts'] = Date.now();
            } else {
              const ts = this.cacheService.getTimestamp(apiKey);
              if(ts) {
                params['ts'] = ts;
              }
            }
          }
            return this.http.get<MappedSHGForCrpRes>(`${this.baseUrl}member/crp-lakhpati-mapping`,{params,headers}).pipe(map((response: MappedSHGForCrpRes) => {
            response.responseData = response.responseData.filter((record: MappedPld) => record.shgId && !record.memberCode && record.crpName && !record.deleted);
            return response;
        }));

        }

    getPld (payload: IPldPayload): Observable<PldRes> {
        const params = new HttpParams()
            .set('stateId', payload.state_id)
            .set('districtId', payload.district_id)
            .set('blockId', payload.block_id)
            .set('panchayatId', payload.panchayat_id)
            .set('villageId', payload.village_id)
            .set('shgCode', payload.shg_code)
            .set('lddStatus', payload.lddStatus.toString())
            .set('page', payload.page.toString())
            .set('size', payload.size.toString());

        let headers;
        const xTenantIdetifier = this.localService.get('X-Tenant-Identifier');
        if (xTenantIdetifier) {
            headers = new HttpHeaders().set('X-Tenant-Identifier', xTenantIdetifier);
        }
        return this.http.get<PldRes>(`${this.lokosBaseUrl}lakhpati-didi`, { params, headers }).pipe(map((response: PldRes) => {
        response.recordsList = response.recordsList.map((pld: any): Pld => {
            return {
                lddId: pld.ldd_id,
                memberName: pld.member_name,
                memberCode: pld.member_code,
                memberId: pld.member_id,
                shgName: pld.shg_name,
                shgCode: pld.shg_code,
                districtId: pld.district_id,
                blockId: pld.block_id,
                panchayatId: pld.panchayat_id,
                villageId: pld.village_id,
                lddStatus: pld.ldd_status,
                remark: pld.remark,
                income_range: pld.income_range,
                checked: pld.checked,
                cbo_id: pld.cbo_id,
                rangeId: pld.range_id,
                frequencyId: pld.frequency_id,
                primaryOccupation: pld.primary_occupation,
                secondaryOccupation: pld.secondary_occupation,
                tertiaryOccupation: pld.tertiary_occupation,
                memberImage: pld.member_image,
                isSurvey: pld.isSurvey,
                memberNameLocal: pld.member_name_local,
                ...pld
            };
        });
            // Transform the response if needed
            return response;
        }));
    }

    getMappedPld (stateId: string, blockId: string): Observable<MappedPldRes> {
      console.log("66666")
        return this.http.get<MappedPldRes>(`${this.baseUrl}member/crp-lakhpati-mapping`, {params: {fullData: 'false', stateId, blockId}});

    }

    updateQuarter (id: string, payload: UpdateQuarterPayload): Observable<QuarterUpdateRes> {
        return this.http.put<QuarterUpdateRes>(`${this.baseUrl}member/${id}/quarter`, {}, {params: {memberId: payload.memberId.toString(), stateId: payload.stateId.toString(), year: payload.year.toString()}});
    }

    getUnmappedMembers (payload: IAajeevikaMemberRedisPayload): Observable<IGetAajeevikaMemberRedisRes> {
        return this.http.get<IGetAajeevikaMemberRedisRes>(`${this.baseUrl}member/unmapped`, {params: {stateId: payload.stateId.toString(), blockId: payload.blockId.toString()}});
    }

    getRejectionDetails (memberUuid: string): Observable<IGetRejectionDetailsRes> {
        return this.http.get<IGetRejectionDetailsRes>(`${this.baseUrl}member/${memberUuid}/rejection`, {params: {memberUuid}});
    }
    getSurveyMember (payload: any,enableCaching = true,forceRefresh = false): Observable<any> {
        const params = new HttpParams()
            .set('stateId', payload.state_id || payload.stateId)
            .set('districtId', payload.district_id || payload.districtId)
            .set('blockId', payload.block_id || payload.blockId);

        let headers;
        const xTenantIdetifier = this.localService.get('X-Tenant-Identifier');
        if (xTenantIdetifier) {
            headers = new HttpHeaders().set('X-Tenant-Identifier', xTenantIdetifier);
        }
        if (enableCaching) {
            const apiKey = this.cacheService.API_KEYS.SURVEY_LISTING;
            const cacheTime = '1200';
            headers = headers ? headers.set('Cache-Control', `private, max-age=${cacheTime}`) : new HttpHeaders().set('Cache-Control', `private, max-age=${cacheTime}`);

             if (forceRefresh) {
              params.set('ts', Date.now().toString());
            } else {
              const ts = this.cacheService.getTimestamp(apiKey);
              if(ts) {
                params.set('ts', ts.toString());
              }
            }
        }
        return this.http.get<PldRes>(`${this.baseUrl}member/${payload.shg_code}/survey-members`, { params, headers });
    }
    getMemberSummary (memberUuid: string, payload:any): Observable<any> {
        return this.http.get(`${this.baseUrl}member/${memberUuid}/summary`, {params: payload})
        .pipe(map((response: any) => {
            // response.responseData.memberDetail.active = false;
            return response;
        }));
    }

    getInactiveDidiList(
        blockId: string,
        forceRefresh = false,
        enableCaching = true,
        cacheTime = '300',
        apiKey = this.cacheService.API_KEYS.INACTIVE_MEMBER_LISTING
    ): Observable<any> {
        const params: any = { blockId };
        let headers = {};

        const xTag = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        if (enableCaching) {
            headers = {
                'Cache-Control': `private, max-age=${cacheTime}`,
                'x-tag': xTag,
            };

            if (forceRefresh) {
                params['ts'] = Date.now();
            } else {
                const ts = this.cacheService.getTimestamp(apiKey);
                if (ts) {
                    params['ts'] = ts;
                }
            }
        }
        return this.http
            .get<InactiveLakhpatiDidiResponse>(
                `${this.baseUrl}member/lakhpatididi/inactive`,
                {
                    headers,
                    params,
                    observe: 'response',
                }
            )
            .pipe(
                tap((response: any) => {
                    if (enableCaching) {
                        const responseXTag = response.headers?.get('x-tag');
                        if (forceRefresh) {
                            this.cacheService.setTimestamp(
                                apiKey,
                                params['ts']
                            );
                        }
                        if (forceRefresh || responseXTag === xTag) {
                            if (this.cacheService.hasDirtyIds(apiKey)) {
                                this.cacheService.clearDirtyIds(apiKey);
                            }
                        }
                    }
                })
            );
    }

}
